import Grid from "@material-ui/core/Grid";
import React from "react";
import useSWR from "swr";
import useTranslation from "next-translate/useTranslation";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import LocaleLink from "../../Navigation/LocaleLink";
import { queryArticles } from "../../../graphql/queries";
import { default as categoriesConfig } from "../../../categoriesArticles.json";

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: theme.spacing(2),
  },
  image: {
    width: 85,
    float: "right",
    marginLeft: 5,
    [theme.breakpoints.up("sm")]: {
      float: "left",
      marginRight: 10,
      marginLeft: 0,
    },
  },
  short: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  title: {},
  titleText: {
    fontFamily: "inherit",
    lineHeight: 1,
    marginBottom: theme.spacing(1),
  },
  contentHeader: {
    marginBottom: theme.spacing(1),
  },
  content: {},
  item: {
    // width: '100%',
    marginBottom: theme.spacing(4),
  },
}));

const ArticleRecommendation = (props) => {
  const { articleId } = props;
  const classes = useStyles();
  const { t, lang: locale } = useTranslation("common");

  const { data } = useSWR([
    queryArticles,
    JSON.stringify({
      action: "search",
      visibility: "public",
      locale,
      categories: categoriesConfig.categoriesInBlog.join(","),
      excludeIds: articleId,
      size: 5,
    }),
  ]);

  if (!data?.queryArticles?.items || data.queryArticles.items.length <= 0) {
    return null;
  }
  const articles = data.queryArticles.items;

  return (
    <Grid container data-test="article-recommendations">
      <Grid item xs={12} className={classes.header}>
        <Typography variant="h5" align="left" component="h2">
          {t("articleRelated")}
        </Typography>
      </Grid>
      {articles.map((article) => (
        <Grid item key={article.id} className={classes.item} xs={12}>
          <LocaleLink notStyled href="/blog/[generic]" as={`/blog/${article.id}`}>
            <div className={classes.contentHeader}>
              {t("articleRecommendationMore", { category: t(`articleCategory_${article.category.replace("-", "_")}`) })}
            </div>
            <div className={classes.content}>
              <div className={classes.title}>
                <img
                  loading="lazy"
                  src={`${article.images[0].uri}-85`}
                  width={85}
                  height={60}
                  alt={article.images[0].alt}
                  className={classes.image}
                />
                <Typography variant="h6" component="h3" className={classes.titleText}>
                  {article.title}
                </Typography>
              </div>
              <div className={classes.short}>{article.short}</div>
            </div>
          </LocaleLink>
        </Grid>
      ))}
    </Grid>
  );
};

export default ArticleRecommendation;
